import { Theme } from '@mui/material';
import styled from '@mui/system/styled';

export const HeroWrapper = styled('div')(({ theme }: { theme?: Theme }) => ({
  color: '#fff',
  overflow: 'hidden',
  margin: '0 auto',
  textAlign: 'left',
  paddingLeft: '10px',
  paddingTop: '60px',
  minHeight: '200px',
  textShadow: '2px 2px 10px rgb(0 0 0 / 25%)',
  [theme.breakpoints.up('sm')]: {
    width: '750px',
    maxWidth: '1100px',
    paddingTop: '180px'
  },
  [theme.breakpoints.up('md')]: {
    width: '970px',
    paddingTop: '130px'
  },
  [theme.breakpoints.up('lg')]: {
    width: '1080px',
    paddingLeft: 0,
    paddingTop: '130px'
  }
}));

export const HeroTitle = styled('h1')(({ theme }: { theme?: Theme }) => ({
  fontFamily: 'Yrsa, serif',
  fontSize: '28px',
  fontWeight: 500,
  lineHeight: 1,
  textShadow: '2px 2px 10px rgb(0 0 0 / 25 %)',
  margin: 0,
  [theme.breakpoints.up('sm')]: {
    fontSize: '56px'
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '72px'
  }
}));

export const HeroSubtitle = styled('h2')(({ theme }: { theme?: Theme }) => ({
  lineHeight: 1,
  fontWeight: 400,
  textShadow: '2px 2px 10px rgb(0 0 0 / 25 %)',
  fontSize: '12px',
  marginTop: '15px',
  [theme.breakpoints.up('sm')]: {
    marginTop: '8px',
    fontSize: '22px'
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '26px',
    lineHeight: '26px',
    marginTop: '15px',
    marginBottom: 0
  }
}));

export const HeroBanners = styled('div')(({ theme }: { theme?: Theme }) => ({
  display: 'none',
  [theme.breakpoints.up('sm')]: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center'
  },
  '& > *': {
    [theme.breakpoints.up('sm')]: {
      margin: '0 30px',
      display: 'inline-block'
    },
    [theme.breakpoints.up('md')]: {
      margin: '0 30px',
      marginBottom: '40px'
    }
  }
}));

export const HeroButtonContainer = styled('div')(
  ({ theme }: { theme?: Theme }) => ({
    marginTop: '20px',
    '& .hero-button': {
      fontSize: '14px',
      fontWeight: '400',
      padding: '7px 25px 4px'
    },
    [theme.breakpoints.up('sm')]: {
      '& .hero-button': {
        fontSize: '16px',
        paddingBottom: '5px'
      }
    }
  })
);
